import { Note } from '../models/domain/note';
import { Member } from '../models/domain/member';
import { Injectable } from '@angular/core';

import { Subject } from 'rxjs/Subject';
import { EntityChangedArgs } from '../managers/manager.base';
import { MemberDashboard } from '../models/ss-api/responses/member.dashboard.response';

@Injectable()
export class MemberEventsService {

    public onSwitchUser = new Subject<number>(); // userid
    public onUserLoad = new Subject<Member>();
    public onMemberDashboardChangeRequest = new Subject<number>(); // MemberID
    public onMemberDashboardLoaded = new Subject<MemberDashboard>();

    public onMemberChanged = new Subject<EntityChangedArgs<Member>>();
    public onNoteChanged = new Subject<EntityChangedArgs<Note>>();

    public onMemberEmailsChanged = new Subject();
}
